import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import Button from "components/Button/Button";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./AdvertiseBusinessOverviewWidget.css";
const AdvertiseBusinessOverviewWidget = () => {
    const data = useStaticQuery(graphql`
        query BsAdQuery {
            mobileImage: file(relativePath: { eq: "bs-ad-mobile-1x.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "bs-ad-web-1x.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);
    return (
        <WidgetContainer stylesClass="advertise-business">
            <div id="advertise-business-faster"></div>
            <div className="advertise-business__container">
                <div className="advertise-business__container__content">
                    <h2>Meet your business goals faster</h2>
                    <p>
                        PhonePe can help you reach a wide user-base with
                        targeted campaigns designed to meet your business needs.
                        Let relevant consumers sample your products and services
                        in the form of ‘reward coupons’ distributed on PhonePe,
                        or advertise within the PhonePe app.
                    </p>
                    <div className="advertise-business__container__content__banner">
                        <Img
                            fluid={data.mobileImage.childImageSharp.fluid}
                            alt="Advertise on PhonePe"
                            imgStyle={{ objectFit: "cover" }}
                        />
                    </div>
                    <div className="advertise-business__container__content__btn-container">
                        <Button
                            btnText="Advertise on PhonePe"
                            pagePath="/business-solutions/merchant-advertisement/"
                            btnStyle="btnStyle"
                        />
                    </div>
                </div>
                <div className="advertise-business__container__img">
                    <Img
                        fluid={data.desktopImage.childImageSharp.fluid}
                        alt="Advertise on PhonePe"
                        imgStyle={{ objectFit: "cover" }}
                    />
                </div>
            </div>
        </WidgetContainer>
    );
};

export default AdvertiseBusinessOverviewWidget;
